import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  Col,
  Container,
  Fade,
  Form,
  FormGroup,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import {
  clear,
  getUsers,
  login,
  recoverAccount,
} from "../redux/actions/authActions";
import Footer from "./partials/Footer";
import Header from "./partials/Header";

const ForgetPassword = (props) => {
  useEffect(() => {
    document.body.classList.add("img-bg");
    window.scrollTo(0, 0);
  }, []);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const history = useHistory();
  return (
    <Fragment>
      <Header {...props} background={false} login={false} />
      <div className="margin-top-fix text-white-1">
        <Container>
          <Row className="mb-5">
            <Col lg={6}>
              <div className="d-flex justify-content-center mt-5 pt-5 align-items-center">
                <div>
                  <h4>Welcome to ClueRush </h4>
                  <h5 className="mt-4">
                    Enter your email you forgot password for <br />
                  </h5>
                </div>
              </div>
            </Col>
            <Col lg={6} className="mt-5 mt-lg-0">
              <div className="form-wrapper">
                {auth.recover && auth.recover.code == 400 && (
                  <Fade
                    in={auth.recover && auth.recover.message}
                    onEnter={(e) =>
                      window.setTimeout(() => {
                        dispatch(clear("recover"));
                      }, 2000)
                    }
                  >
                    <Alert
                      isOpen={auth.recover && auth.recover.message}
                      color="danger"
                    >
                      {auth.recover && auth.recover.message}
                    </Alert>
                  </Fade>
                )}
                {auth.recover && auth.recover.code == 200 && (
                  <Fade
                    in={auth.recover && auth.recover.message}
                    onEnter={(e) =>
                      window.setTimeout(() => {
                        dispatch(clear("recover"));
                        history.push("/login");
                      }, 5000)
                    }
                  >
                    <Alert
                      isOpen={auth.recover && auth.recover.message}
                      color="success"
                    >
                      {auth.recover && auth.recover.message}
                    </Alert>
                  </Fade>
                )}
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    let obj = {
                      email: e.target.email.value,
                    };
                    dispatch(recoverAccount(obj));
                  }}
                >
                  <FormGroup>
                    <Input
                      type="text"
                      placeholder="Email"
                      className="form-control"
                      name="email"
                    />
                  </FormGroup>
                  <Button
                    type="submit"
                    block
                    disabled={auth.recover == -1}
                    className="w-100 mt-3 bg-purple-1 border-0 py-4"
                    style={{ borderRadius: 24 }}
                  >
                    {auth.recover == -1 ? <Spinner /> : "Recover"}
                  </Button>
                </Form>
                <small className="d-block mt-5 text-center font-2 text-capitalize">
                  don’t have an account ?{" "}
                  <Link
                    to="/register"
                    className="text-red-1"
                    style={{ fontWeight: 700, textDecoration: "none" }}
                  >
                    Sign Up
                  </Link>
                </small>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <br />
      <br />
      <br />
      <Footer></Footer>
    </Fragment>
  );
};

export default ForgetPassword;
